import Vue from 'vue'
import App from './App'
// import router from '../../router/router';

/* eslint-disable no-new */
new Vue({
  // router,
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/module/technology/technology.js